import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavModule
} from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { NotificationAreaComponent } from '@app/components/shared/notification-area/notification-area.component';
import { Router, RouterOutlet } from '@angular/router';
import { ToolbarComponent } from '@app/components/shared/toolbar/toolbar.component';
import { Observable, of, Subject } from 'rxjs';
import { MenuItem } from '@app/components/shared/button-menue/model/menu-item';
import { delay, filter, takeUntil } from 'rxjs/operators';
import { HttpStatusService } from '@app/services/http-status/http-status.service';
import { PasswordService } from '@app/services/password/password.service';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatRipple } from '@angular/material/core';
import { MenuFacadeService } from '@app/facade-services/menu/menu-facade.service';
import { DialogFacadeService } from '@app/facade-services/dialog/dialog-facade.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { SelectedRaceService } from '@app/services/selected-race.service';
import { defined } from '@app/fremework/functions';
import { Authorization } from '@app/services/password/model/user-token';
import { Roles } from '@app/services/password/model/roles';
import { PreviousRouteService } from '@app/services/previous-route/previous-route.service';
import { SnackComponent } from '@app/components/shared/snack/snack.component';
import { MatButtonModule } from '@angular/material/button';
import { Race } from '@app/rest-client/faxe/models/race';
import { PageId } from '@app/constants/page-id';

@Component({
  selector: 'faxe-page-layout',
  imports: [
    CommonModule,
    MatProgressBar,
    NotificationAreaComponent,
    RouterOutlet,
    ToolbarComponent,
    MatListModule,
    MatIconModule,
    MatDividerModule,
    MatRipple,
    MatSidenavContainer,
    MatSidenavModule,
    SnackComponent,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './page-layout.component.html',
  styleUrl: './page-layout.component.scss'
})
export class PageLayoutComponent implements OnInit, OnDestroy {
  @Input() numOfCols: number;
  @Input() showClock: boolean;
  @Input() showAndonMenu: boolean;
  private clickCounter = 0;
  private clickTimeout: any;
  @Input() set toggleMenu(value: boolean) {

    if (value && !this.drawer.opened) {
      this.menuClick(this.drawer);
    }
  }

  @ViewChild('drawer') drawer!: MatSidenav;
  dialogClosed$: Observable<boolean> = of(false);
  loading$: Observable<boolean>;
  height: 0;

  menuItemsSteward: MenuItem<string>[];
  menuItemsAdmin: MenuItem<string>[];
  menuItemsManager: MenuItem<string>[];
  menuItemsPublic: MenuItem<string>[];

  menuItemsSupport: MenuItem<string>[];
  menuItemsRace: MenuItem<string>[];

  selectedRace$: Observable<Race>;
  isViewer: boolean;
  time = new Date();
  intervalId: NodeJS.Timeout;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private httpStatusService: HttpStatusService,
    private dialogFacadeService: DialogFacadeService,
    private router: Router,
    private passwordService: PasswordService,
    private menuFacadeService: MenuFacadeService,
    private confirmationDialog: MatDialog,
    private selectedRaceService: SelectedRaceService,
    private previousRouteService: PreviousRouteService) {
  }

  ngOnInit(): void {
    this.selectedRace$ = this.selectedRaceService.selectedRace$;
    this.isViewer = this.passwordService.isViewer();

    this.dialogClosed$ = this.dialogFacadeService
      .isDialogClosed()
      .pipe(takeUntil(this.unsubscribe$), delay(0));

    this.loading$ = this.httpStatusService.loading$.pipe(
      takeUntil(this.unsubscribe$),
      delay(0)
    );

    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);

    if (this.previousRouteService.inRootFromRoot()) {
      this.selectedRaceService.selectedRace$
        .pipe(takeUntil(this.unsubscribe$), filter(_ => defined(_)))
        .subscribe(selectedRace => {
          this.getAuthorizationBuildMenu(true, selectedRace.raceGuid);
        });
    }

    this.buidSupportMenu();
    this.buidRaceMenu();

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    clearInterval(this.intervalId);
  }

  onHeight($event: number): void {
    this.renderer.setStyle(
      this.elementRef.nativeElement.querySelector('#page-content'),
      'padding-top',
      '5px'
      //`${$event}px`
    );
  }

  menuItemClick(item: MenuItem<string>, drawer: MatSidenav) {
    drawer.toggle()
      .then(() =>  this.router.navigate([item.value]));
  }

  menuClick(drawer: MatSidenav) {
    if (!defined(this.selectedRaceService.selectedRaceGuid)) {
      this.openDialogSelectRace();
    } else {
      this.menuItemsPublic = this.menuFacadeService.getPublicMenu();
      this.getAuthorizationBuildMenu(false, this.selectedRaceService.selectedRaceGuid);
      drawer.toggle();
    }
  }

  getAuthorizationBuildMenu(autoNavigate: boolean, raceGuid?: string) {
    const userToken = this.passwordService.getUserToken(this.selectedRaceService.selectedRaceGuid);
    this.buidMenu(userToken.authorization
        .find(authorization => authorization.raceGuid === raceGuid),
      autoNavigate);
  }

  buidMenu(authorization: Authorization, autoNavigate: boolean) {
    this.menuItemsSteward = this.menuFacadeService.getStewardMenu(authorization.roles);
    this.menuItemsAdmin = this.menuFacadeService.getsAdminMenu(authorization.roles);
    this.menuItemsManager = this.menuFacadeService.getManagerMenu(authorization.roles);

    if (autoNavigate && authorization.roles.length === 1) {
      Object.values(Roles).forEach(role => {
        if (role === authorization.roles[0]) {
          this.menuFacadeService.navigateTo(role);
        }
      });
    }
  }

  buidSupportMenu() {
    this.menuItemsSupport = this.menuFacadeService.getSupportMenu()
  }

  buidRaceMenu() {
    this.menuItemsRace = this.menuFacadeService.getRaceMenu()
  }

  openDialogSelectRace() {
    this.confirmationDialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Välj tävling',
        message: 'Du måste välja en tävling för att kunna fortsätta.',
        bulletList: undefined,
        primaryButton: 'Stäng',
        correlationId: 'select-race'
      }
    })
      .afterClosed()
      .subscribe();
  }

  protected readonly Boolean = Boolean;

  raceClassClick() {
    this.clickCounter++;

    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout);
    }

    this.clickTimeout = setTimeout(() => {
      this.clickCounter = 0; // Reset the counter after 1 second
    }, 1000);

    if (this.clickCounter === 3) {
      this.triggerAction();
      this.clickCounter = 0; // Reset the counter after triggering the action
    }
  }

  private triggerAction() {
    this.router.navigate([`/${PageId.adminHome}`]);
  }
}
